import { render, staticRenderFns } from "./TeacherDetail.vue?vue&type=template&id=da13b706&scoped=true&"
import script from "./TeacherDetail.vue?vue&type=script&lang=js&"
export * from "./TeacherDetail.vue?vue&type=script&lang=js&"
import style0 from "./TeacherDetail.vue?vue&type=style&index=0&id=da13b706&lang=scss&scoped=true&"
import style1 from "./TeacherDetail.vue?vue&type=style&index=1&id=da13b706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da13b706",
  null
  
)

/* custom blocks */
import block0 from "./TeacherDetail.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports